import React from 'react';
import TextField from '@mui/material//TextField';
import Autocomplete, { createFilterOptions } from '@mui/material/Autocomplete';
import { connect } from 'react-redux';
import setProductAction from '../../redux/actions/createReferenceActions/actionProduct'
import { withTranslation } from 'react-i18next';


const filterOptions = createFilterOptions({
    ignoreAccents: true,
    limit: 20,
});

class ProductForm extends React.Component {

    constructor(props) {
        super(props);
        this.state = { product: '', products: { data: [{ 'productname': '' }] }, errorAmount: false, errorRequired: false };
        this.handleChange = this.handleChange.bind(this);
        this.handleChangeForm = this.handleChangeForm.bind(this);
        this.props.setProductFunction('defaultProduct')
    }

    // fetch by adding charachters in product-inputform
    async handleChange(event) {

        this.setState({ product: event.target.value });

        const response = await fetch(`${process.env.REACT_APP_EXPRESS_SERVER}/createRef/products?language=${localStorage.getItem('language')}`);
        const json = await response.json();
        // console.log(json)
        this.setState({ products: json });
    };

    handleChangeForm(event, value) {

        if (value !== null) {
            if (Object.keys(value).length <= 9) {
                this.setState({ product: value }, () => {
                    this.props.setProductFunction(this.state.product)
                });
                this.setState({ errorAmount: false });
            } else {
                this.setState({ errorAmount: true });
            }

            //error handling: min 1 product
            if (Object.keys(value).length < 1) {
                this.setState({ errorRequired: true });
            } else {
                this.setState({ errorRequired: false });
            }

        } else {
            this.setState({ product: 'defaultProduct' }, () => {
                this.props.setProductFunction(this.state.product);
            });
        }
    }

    render() {
        const { t } = this.props;
        return (
            <div>
                <Autocomplete
                    multiple
                    id="combo-box-product"
                    limitTags={1}
                    filterOptions={filterOptions}
                    autoComplete={true}
                    onChange={this.handleChangeForm}
                    options={this.state.products.data}
                    getOptionLabel={(option) => option.productname}
                    isOptionEqualToValue={(option, value) => option.productname === value.productname}
                    getOptionDisabled={() => this.state.errorAmount ? true : false}
                    noOptionsText={'Wrong input data'}
                    sx={{
                        "&:hover ": {
                            borderColor: "rgb(0,191,255)"
                        },
                        '& label.Mui-focused': {
                            color: 'white'
                        },
                        '& .MuiAutocomplete-tag':{
                            color: 'black',
                            backgroundColor: "white",
                        },
                        input: { color: 'white'  },
                        '& .MuiOutlinedInput-root': {
                            '&:hover fieldset': {
                                borderColor: 'rgb(0,191,255)',
                            },
                            '&.Mui-focused fieldset': {
                                borderColor: 'rgb(47, 79, 79)',
                            },
                        },
                    }}
                    renderInput={(params) => (<TextField {...params} sx={{
                        input: { color: 'white'  },
                        // '.MuiSvgIcon-root ': {
                        //     fill: "white !important",
                        // }
                    }} 
                    style={{ fontSize: 30, color:'secondary', backgroundColor: 'rgba(19, 174, 236, 0.54)', width: 300 }}
                        onChange={this.handleChange} variant="outlined" error={this.props.errorRequiredProd} label={t("create_ref.products_label")} placeholder={t("create_ref.products_placeholder")} />)}
                />
            </div>
        );

    }
}
function mapStateToProps(state) {
    return {
        errorRequiredProd: state.createRefState.errorRequiredProd
    }
}

// set props to redux-store
function mapDispatchToProps(dispatch) {
    return {
        setProductFunction: product => {
            dispatch(setProductAction(product))
        }
    }
}

export default connect(mapStateToProps, mapDispatchToProps)((withTranslation()(ProductForm)));